import { getReadableValue } from './getset'

const keyFromId = {
  distriktFilter: 'reinbeitebruker_id_before', kartlagFilter: 'layer_name'
};
const toLabel = { Punkt: 'Anlegg (punkt)', Linje: 'Anlegg (linje)' };

const maxChanges = 120;
export const filterAndLimitChangesOverview = () => {
  const tot = overviewBody.rows.length;
  const d = distriktFilter.value;
  const k = kartlagFilter.value;
  let count = 0;
  overviewFoot.hidden = true;
  overviewBody.querySelectorAll(':scope > tr').forEach(tr => {
    // console.log(tr.classList, d, k);
    tr.hidden = !tr.classList.contains(d) || !tr.classList.contains(k);
    if (!tr.hidden) count++;
    // We needed to limit the number of displayed maps:
    if (count > maxChanges) {
      tr.hidden = true;
      if (count === maxChanges + 1) {
        manglendeEndringer.innerHTML = tot - maxChanges;
        overviewFoot.hidden = false;
      }
    }
  });
};

const createOption = (value, label) => {
  const o = document.createElement('option');
  o.value = value;
  o.innerHTML = label || value;
  return o;
};

export const updateDistriktFilter = set => {
  for (let i = distriktFilter.length - 1; i > 0 ; i--) distriktFilter.remove(i);
  set.forEach(d => distriktFilter.appendChild(
    createOption(d, `${d} (${getReadableValue(d, 'reinbeitebruker')})`)
  ));
};

export const updateKartlagFilter = set => {
  for (let i = kartlagFilter.length - 1; i > 0 ; i--) kartlagFilter.remove(i);
  set.forEach(k => kartlagFilter.appendChild(createOption(k, toLabel[k])));
};
